
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslationService, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Router } from '@angular/router';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { CustomProfileService } from '../../../core/services/custom-profile.service';
import { pairwise, tap } from 'rxjs/operators';
import { WindowRef } from '@spartacus/core';
import { ToastrService } from 'ngx-toastr';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgFor, TitleCasePipe } from '@angular/common';
@Component({
    selector: 'app-custom-contacts',
    templateUrl: './custom-contacts.component.html',
    styleUrls: ['./custom-contacts.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, NgFor, TitleCasePipe, I18nModule]
})
export class CustomContactsComponent implements OnInit {

  enableLoader = true;
  contacts: any;
  errorMessage: any;
  updatecontact: any;
  contactdetails: any = 'false';
  title: any;
  activeindicator: boolean;
  navigationData: string;
  addupdate = false;
  users: any;
  activeusers: any;
  token: any;
  loggedinUser: any;
  admin: any;
  userid: any;
  usergroup: any;
  customerId: any;
  noData = false;
  route: any;
  companyName: any;
  constructor(
    private userAccountFacade: UserAccountFacade,private toastService: ToastrService,
    private customProfileService: CustomProfileService,
    private translation: TranslationService,
    private winRef: WindowRef,
    private cd: ChangeDetectorRef, private router: Router, private customProductService: CustomProductsService ) { }

  ngOnInit(): void {
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.userAccountFacade.get().subscribe((data: any) => {
      if (data) {
        if (this.winRef.localStorage.getItem('groupCompanyAdminFlag') !== undefined) {
          this.admin = JSON.parse(this.winRef.localStorage.getItem('groupCompanyAdminFlag'));
        }
        if (this.winRef.localStorage.getItem('grpCompanyName') !== undefined && this.winRef.localStorage.getItem('grpCompanyName') !== 'undefined') {
          this.companyName = this.winRef.localStorage.getItem('grpCompanyName');
        }else{
          this.companyName = '';
        }
        this.userid = data.uid;
        this.customerId = data.customerId;
        this.usergroup = this.customProfileService.getGroupCompany();
       // this.usergroup = data.orgUnit.uid;
        this.cd.detectChanges();
        this.getContacts();
        this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              this.enableLoader = true;
              if (this.router.url === '/companies/myCompany/contacts/detail') {
                this.getContacts();
              }
            }
          }
        });
      }
    });

    this.translation.translate('breadcrumb.contacts.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.contacts.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });

  }
  receiveMessage($event): any {
    this.contactdetails = $event;
    this.getContacts();
    this.cd.detectChanges();
  }
  navigateToDetails(customer): any {
    this.contactdetails = true;
    this.addupdate = false;
    this.updatecontact = customer;
  }
  navigateToaddcontact(): any {
    this.contactdetails = true;
    this.addupdate = true;
  }
  getContacts(): any {
    this.customProfileService.getcontacts(this.usergroup).subscribe(res => {
    //this.customProfileService.getContactData().pipe(tap(_=>console.log(_))).subscribe((data:any) => {
      
        if (res) {
          this.enableLoader = false;
          this.contacts = res;
          
          this.noData = false;
          // this.contacts = this.contacts.users.filter((us: { selected: boolean; }) => {
          //   return us.selected === true;
          // });
          this.contacts=this.contacts.users;
          this.contacts = this.contacts.map((us: { orgUnit: any; }) => {
            if (us.orgUnit.uid !== this.usergroup){
              us.orgUnit.name = this.companyName;
            }
            return us;
          });
          if (this.contacts.length === 0){
            this.noData = true;
          }
          this.cd.detectChanges();
        }
        else{
          this.toastService.show('Error loading this page:'+(res));
        }
      }, (error) => {
        this.errorMessage = error;
        this.toastService.show("Sorry something went wrong, please try again!")
        this.enableLoader = false;
      // });
    })
  }
  openDetailscontact(contact): any {
    this.customProductService.contactData = contact;
    localStorage.setItem("contactId", contact.uid);
    this.router.navigate([`companies/myCompany/contacts/detail/Update/${contact.uid}`], { state: contact, relativeTo: this.route });
  }
  openaddcontact(): any {
    this.customProductService.addData = true;
    this.router.navigate([`companies/myCompany/contacts/detail/add`]);
  }
}
